const sentryEnvMap = {
    test: 'test',
    local: 'local',
    dev: 'dev',
    ci: 'ci',
    stage: 'stage',
    prod: 'prod',
    production: 'prod',
    development: 'dev',
};
function toEnv(val) {
    if (typeof val === 'string') {
        return sentryEnvMap[val] || '';
    }
    return '';
}
export function buildSentryConfig(config, log) {
    var _a, _b, _c, _d, _e, _f, _g;
    if (log) {
        checkSentryConfig(config, log);
    }
    const opts = {
        dsn: ((_a = config.sentry) === null || _a === void 0 ? void 0 : _a.dsn) || '',
        release: config.release || config.version,
        environment: toEnv((_b = config.sentry) === null || _b === void 0 ? void 0 : _b.env),
        sampleRate: (_c = config.sentry) === null || _c === void 0 ? void 0 : _c.sampleRate,
        clientName: (_d = config.sentry) === null || _d === void 0 ? void 0 : _d.clientName,
        serverName: (_e = config.sentry) === null || _e === void 0 ? void 0 : _e.serverName,
        fxaName: ((_f = config.sentry) === null || _f === void 0 ? void 0 : _f.clientName) || ((_g = config.sentry) === null || _g === void 0 ? void 0 : _g.serverName),
    };
    return opts;
}
function checkSentryConfig(config, log) {
    var _a, _b;
    if (!config || !config.sentry || !((_a = config.sentry) === null || _a === void 0 ? void 0 : _a.dsn)) {
        raiseError('sentry.dsn not specified. sentry disabled.');
        return;
    }
    else {
        log === null || log === void 0 ? void 0 : log.info('sentry-config-builder', {
            msg: `Config setting for sentry.dsn specified, enabling sentry for env ${config.sentry.env}!`,
        });
    }
    if (!config.sentry.env) {
        raiseError('config missing either environment or env.');
    }
    else if (!toEnv(config.sentry.env)) {
        raiseError(`invalid config.env. ${config.sentry.env} options are: ${Object.keys(sentryEnvMap).join(',')}`);
    }
    else {
        log === null || log === void 0 ? void 0 : log.info('sentry-config-builder', {
            msg: 'sentry targeting: ' + sentryEnvMap[config.sentry.env],
        });
    }
    if (!config.release && !config.version) {
        raiseError('config missing either release or version.');
    }
    if (((_b = config.sentry) === null || _b === void 0 ? void 0 : _b.sampleRate) == null) {
        raiseError('config missing sentry.sampleRate');
    }
    if (!config.sentry.clientName && !config.sentry.serverName) {
        raiseError('config missing either sentry.clientName or sentry.serverName');
    }
    function raiseError(msg) {
        var _a;
        log === null || log === void 0 ? void 0 : log.warn('sentry-config-builder', { msg });
        if ((_a = config.sentry) === null || _a === void 0 ? void 0 : _a.strict) {
            throw new SentryConfigurationBuildError(msg);
        }
    }
}
class SentryConfigurationBuildError extends Error {
}
